import React from "react";
import GenericTable from "../../../../../../shared-library/components/GenericTable";
var NominationDetails = function (props) {
    var nominationColumns = [
        {
            columnName: "Account Code",
            key: "accountcode",
        },
        {
            columnName: "Nomination Name",
            keysForCustomFunction: ["firstName", "middleName", "lastName"],
            tdCustomFunction: function (keys) {
                return (React.createElement("span", null,
                    keys[0],
                    " ",
                    keys[1],
                    " ",
                    keys[2]));
            },
        },
        {
            columnName: "Relationship",
            key: "relationType",
        },
        {
            columnName: "Percentage",
            key: "nomineePercentage",
            tdCustomFunction: function (key) {
                return React.createElement("span", null,
                    key,
                    "%");
            },
        },
    ];
    return (React.createElement(GenericTable, { columns: nominationColumns, data: props.nominationData, loader: props.showLoader, 
        //   parentClassName="salestableParentClass table-responsive commonscroll-new"
        parentClassName: "nomination-table common-modal-table", 
        //   tableClassName="nomination-table"
        message: {
            msg: "No Data Found",
            show: props.nominationData.length === 0 ? true : false,
            icon: "",
        } }));
};
export default NominationDetails;
